<template>
  <div class="green-finance-award">
    <!--  活动 绿色金融奖  -->
    <img class="gfa-banner" src="../../../assets/other/banner.jpg" alt="">

    <div class="gfa-center gfa-nav-list">
      <div class="item" v-for="(item, i) in navList" :key="i" @click="scrollToBlock(item.href, item.link)">
        <img :src="require('../../../assets/other/' + item.icon)" alt="">
        <p>{{item.title}}</p>
      </div>
    </div>

    <div id="box-1" class="gfa-center box-1">
      <div class="block-title">
        <div class="tit">
          <img src="../../../assets/other/l-line-1.png" alt="">
          <span>关于奖项</span>
          <img src="../../../assets/other/r-line-1.png" alt="">
        </div>
        <div class="en-tit">About Awards</div>
      </div>
      <p class="txt mar-txt">当前，全球气候变化与环境保护等问题已成为国际社会共同面临的严峻挑战，走绿色、低碳、可持续发展道路具有重要现实意义。作为促进可持续发展的重要保障和推进绿色发展的路径之一，绿色金融在我国的发展方兴未艾。</p>
      <p class="txt">在此背景下，绿色金融60人论坛（简称GF60）作为国际化绿色金融交流平台，发起主办“GF60绿色金融奖”评选活动，旨在甄选和表彰绿色金融领域内的优秀代表，并将成功实践在全球范围内进行推广，给绿色发展提供价值经验和示范样本，更好推动绿色金融助力经济社会绿色低碳转型。</p>

      <div class="sign-in-btn">
        <div @click="showModal">立即报名</div>
      </div>
    </div>

    <div id="box-2" class="gfa-center box-2">
      <div class="block-title">
        <div class="tit">
          <img src="../../../assets/other/l-line-1.png" alt="">
          <span>奖项设置</span>
          <img src="../../../assets/other/r-line-1.png" alt="">
        </div>
        <div class="en-tit">Awards Setting</div>
      </div>
      <p class="txt">本次评选秉承“公正、客观、透明”的原则，运用科学的模型和研究方法，对参评案例进行严谨调研和初步甄选，再由评委会专家进行复审，遴选出具有代表性的绿色金融领域优秀金融机构和创新解决方案，鼓励不断探索绿色金融发展创新，为实现双碳目标及经济绿色低碳转型贡献力量。</p>

      <div class="award-list">
        <div class="award-item" v-for="(item, i) in awardList" :key="i">
          <div class="icon">
            <img src="../../../assets/other/5.png" alt="">
          </div>
          <div class="con">
            <p class="a-tit">{{item.tit}}</p>
            <p class="txt a-txt">{{item.txt}}</p>
          </div>
        </div>
      </div>
    </div>

    <img class="block-img" src="../../../assets/other/flow.jpg" alt="">

    <div id="box-3" class="gfa-center box-3">
      <div class="block-title bt2">
        <div class="tit">
          <img src="../../../assets/other/l-line.png" alt="">
          <span>评奖流程</span>
          <img src="../../../assets/other/r-line.png" alt="">
        </div>
        <div class="en-tit">Agenda</div>
      </div>
      <div class="agenda-list">
        <div class="item" v-for="(item, i) in agendaList" :key="i">
          <div class="al-tit">
            <span>{{item.tit1}}</span>
            <span>{{item.tit2}}</span>
            <span>{{item.time}}</span>
          </div>
          <p class="al-txt">{{item.txt}}</p>
        </div>
      </div>
    </div>

    <div id="box-4" class="gfa-center box-4">
      <div class="block-title bt2">
        <div class="tit">
          <img src="../../../assets/other/l-line.png" alt="">
          <span>评委会</span>
          <img src="../../../assets/other/r-line.png" alt="">
        </div>
        <div class="en-tit">Jury Committee</div>
      </div>

      <div class="expert-list">
        <div class="item" v-for="(item, i) in expertList" :key="i">
          <img :src="require('../../../assets/other/pszj/' + item.icon)" alt="">
          <div :class="{'el-tit': true, 'el-tit-en': item.enName}">{{item.title}}</div>
          <div class="el-txt">
            <p v-for="(citem, ci) in item.desc.split('|')" :key="ci">{{citem}}</p>
          </div>
        </div>
      </div>
      <div class="point-msg">
        *以上按姓氏首字母排列
      </div>
    </div>

    <div class="gfa-center gfa-footer">
      <div class="f-left">
        <p>您也可以联系活动主办方获取更多信息</p>
        <p>联系电话：021-62680166-815</p>
        <p>电子邮箱：contact@jinsinan.com.cn</p>
      </div>
      <div class="f-right">
        <img src="../../../assets/code.jpg" alt="">
        <span>GF60公众号</span>
      </div>
    </div>

    <div class="modal" v-show="modalVisible">
      <div class="mask"></div>
      <div class="modal-wrap">
        <div class="modal-box">
          <p>请填写以下信息，主办方将于1-3个工作日内发送参评所需材料内容至您的邮箱。</p>
          <div class="form">
            <div class="item">
              <div class="inp-wrap">
                <div class="label">单位名称</div>
                <input :class="{errInp: formErr.companyName}" type="text" v-model="signMsg.companyName">
              </div>
              <p class="err-msg" :style="{opacity: formErr.companyName ? 1 : 0}">{{formErrMsg.companyName}}</p>
            </div>
            <div class="item">
              <div class="inp-wrap">
                <div class="label">联系人</div>
                <input :class="{errInp: formErr.userName}" type="text" v-model="signMsg.userName">
              </div>
              <p class="err-msg" :style="{opacity: formErr.userName ? 1 : 0}">{{formErrMsg.userName}}</p>
            </div>
            <div class="item">
              <div class="inp-wrap">
                <div class="label">联系电话</div>
                <input :class="{errInp: formErr.mobile}" type="text" v-model="signMsg.mobile">
              </div>
              <p class="err-msg" :style="{opacity: formErr.mobile ? 1 : 0}">{{ formErrMsg.mobile }}</p>
            </div>
            <div class="item">
              <div class="inp-wrap">
                <div class="label">邮箱地址</div>
                <input :class="{errInp: formErr.email}" type="text" v-model="signMsg.email">
              </div>
              <p class="err-msg" :style="{opacity: formErr.email ? 1 : 0}">{{formErrMsg.email}}</p>
            </div>
          </div>
          <div class="submit-btn" @click="clickSubmit">提&nbsp;&nbsp;交</div>
        </div>
        <div class="close-btn" @click="hideModal">X</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GreenFinanceAward",
  data() {
    return {
      formErr: {
        userName: false,
        mobile: false,
        email: false,
        companyName: false
      },
      signMsg: {
        companyName: '',
        mobile: '',
        email: '',
        userName: ''
      },
      formErrMsg: {
        companyName: '请输入单位名称',
        mobile: '请输入联系电话',
        email: '请输入邮箱地址',
        userName: '请输入联系人'
      },
      modalVisible: false,
      navList: [
        {
          title: '关于奖项',
          icon: '1.png',
          href: 'box-1'
        }, {
          title: '奖项设置',
          icon: '2.png',
          href: 'box-2'
        }, {
          title: '评奖流程',
          icon: '3.png',
          href: 'box-3'
        }, {
          title: '评委会',
          icon: '4.png',
          href: 'box-4'
        }, {
          title: '关于GF60',
          icon: '6.png',
          link: 'https://gf60.org.cn/mobile/forum'
        }
      ],
      awardList: [
        {
          tit: '最佳金融机构奖',
          txt: '该奖项面向各类型金融机构，授予在绿色金融领域具有突出贡献，且产生显著的经济、环境或社会价值的机构。'
        },
        {
          tit: '最佳创新实践奖',
          txt: '该奖项面向各类金融机构、产业机构，授予在绿色金融领域有所创新，且产生显著的经济、环境或社会影响的案例。 '
        }
      ],
      agendaList: [
        {
          tit1: '第一阶段',
          tit2: '参评申报',
          // time: '2022.01.14 - 02.13',
          txt: '参评案例或机构依照申报要求自主提交材料。'
        },
        {
          tit1: '第二阶段',
          tit2: '调研初审',
          // time: '2022.02.14 - 03.06',
          txt: '调研核实申报材料，依据评选标准进行初审，产生候选名单。'
        },
        {
          tit1: '第三阶段',
          tit2: '专家评审',
          // time: ' 2022.03.07 - 03.20',
          txt: '评委会专家对候选对象进行综合评价，确定最终获奖名单。'
        }
      ],
      expertList: [
        {
          icon: 'csy.png',
          title: '陈诗一',
          desc: '安徽大学党委副书记|常务副校长'
        }, {
          icon: 'hyx.png',
          title: '洪永淼',
          desc: '中国科学院大学经济与|管理学院院长'
        }, {
          icon: 'hzl.png',
          title: '胡祖六',
          desc: '大自然保护协会亚太区理事会|联合主席、春华资本创始人'
        }, {
          icon: 'lmk.png',
          title: '刘明康',
          desc: '原中国银监会主席|绿色金融60人论坛学术委员会教授'
        }, {
          icon: 'lsh.png',
          title: '廖双辉',
          desc: '上海金司南金融研究院理事长|绿色金融60人论坛秘书长'
        }, {
          icon: 'lxm.png',
          title: '赖晓明',
          desc: '上海环境能源交易所董事长'
        }, {
          icon: 'pp.png',
          title: '彭澎',
          desc: '中国新能源电力投融资联盟|秘书长'
        }, {
          icon: 'wj.png',
          title: '翁瑾',
          desc: '复旦大学全球旅游经济与|文化研究中心主任'
        }, {
          icon: 'xl.png',
          title: '薛领',
          desc: '北京大学城市与区域管理系|主任'
        }, {
          icon: 'zjj.png',
          title: '张俊杰',
          desc: '绿色金融60人论坛|首席经济学家'
        }, {
          icon: 'zxm.png',
          title: '朱晓明',
          desc: '中欧国际工商学院管理学|教授、原院长'
        }, {
          icon: 'zyy.png',
          title: '张云燕',
          desc: '北京金诚同达（上海）律师事务所高级合伙人'
        }
      ]
    }
  },
  methods: {
    scrollToBlock(id, link) {
      if(id) {
        document.getElementById(id).scrollIntoView({ block: 'start', behavior: 'smooth' })
      } else {
        window.open(link);
      }
    },
    touchMove(e) {
      e.preventDefault();
    },
    showModal() {
      this.modalVisible = true;
      document.addEventListener('touchmove', this.touchMove, {passive: false});
    },
    hideModal() {
      this.modalVisible = false;
      this.formErr = {
        userName: false,
        mobile: false,
        email: false,
        companyName: false
      };
      this.formErrMsg = {
        mobile: '请输入联系电话',
        email: '请输入邮箱地址',
        userName: '请输入联系人',
        companyName: '请输入单位名称'
      };
      this.signMsg = {
        mobile: '',
        email: '',
        userName: '',
        companyName: ''
      };
      document.removeEventListener('touchmove', this.touchMove);
    },
    clickSubmit() {
      let nextFlag = true;
      for(let key in this.signMsg) {
        const str = this.signMsg[key];
        if(!str) {
          this.formErr[key] = true;
          nextFlag = false;
          switch (key) {
            case 'mobile':
              this.formErrMsg[key] = '请输入联系电话';
              break;
            case 'email':
              this.formErrMsg[key] = '请输入邮箱地址';
              break;
          }
        } else {
          if(key === 'mobile') {
            const reg = /^1[3-9]\d{9}$/;
            if(reg.test(str)) {
              this.formErr[key] = false;
            } else {
              nextFlag = false;
              this.formErr[key] = true;
              this.formErrMsg[key] = '电话号码格式不正确';
            }
          } else if(key === 'email') {
            const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(reg.test(str)) {
              this.formErr[key] = false;
            } else {
              nextFlag = false;
              this.formErr[key] = true;
              this.formErrMsg[key] = '邮箱格式不正确';
            }
          } else {
            this.formErr[key] = false;
          }
        }
      }
      if(nextFlag) {
        this.saveUserInfo();
      }
    },
    saveUserInfo() {
      this.$http.saveUserInfo(this.signMsg).then(res => {
        alert('报名成功');
        this.hideModal();
      });
    }
  }
}
</script>

<style lang="less">
.mobile-home {
  .green-finance-award {
    .modal {
      .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: #00000070;
      }
      .modal-wrap {
        width: 308px;
        height: 419px;
        position: fixed;
        top: calc((100vh - 419px) / 2);
        left: calc((100vw - 308px) / 2);
        z-index: 2;
        .modal-box {
          position: absolute;
          top: 0;
          left: 0;
          padding-top: 100px;
          width: 308px;
          height: 419px;
          overflow: hidden;
          border-radius: 6px;
          background-image: url("../../../assets/other/modal-bg.jpg");
          background-size: 100%;
          >p {
            width: 236px;
            margin: 13px auto 20px;
            color: #fff;
            font-size: 12px;
            line-height: 20px;
          }
          .form {
            width: 236px;
            margin: 0 auto;
            .item {
              .inp-wrap {
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 2px;
                *> {
                  display: inline-block;
                  vertical-align: middle;
                }
                .label {
                  text-align: justify;
                  height: 20px;
                  width: 57px;
                  color: #fff;
                  &:after {
                    content:"";
                    display:inline-block;
                    width:100%;
                  }
                }
                input {
                  box-sizing: border-box;
                  width: 164px;
                  margin-left: 15px;
                  border: 1px solid #ffffff60;
                  background: transparent;
                  border-radius: 2px;
                  height: 24px;
                  font-size: 12px;
                  color: #fff;
                  padding: 5px 10px;
                }
              }
              .err-msg {
                text-align: right;
                font-size: 12px;
                color: #f00;
              }
            }
          }
          .submit-btn {
            width: 105px;
            height: 27px;
            background: #ffffff30;
            color: #fff;
            text-align: center;
            line-height: 27px;
            font-size: 16px;
            margin: 10px auto;
            border-radius: 5px;
          }
        }
        .close-btn {
          background: #ffffff60;
          color: #fff;
          font-size: 18px;
          width: 28px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          border-radius: 50%;
          position: absolute;
          right: -13px;
          top: -13px;
        }
      }
    }
    .block-img {
      display: block;
      width: 100%;
    }
    .gfa-banner {
      display: block;
      width: 100%;
    }
    .gfa-center {
      padding: 0 30px;
    }
    .gfa-nav-list {
      background: #1D6F8C;
      padding-top: 30px;
      padding-bottom: 42px;
      display: flex;
      justify-content: space-between;
      text-align: center;
      color: #fff;
      font-weight: 400;
      img {
        width: 28px;
        display: block;
        margin: 0 auto 13px;
      }
    }
    .block-title {
      margin-bottom: 26px;
      .tit {
        font-size: 0;
        display: flex;
        justify-content: space-between;
        >* {
          align-self: center;
        }
        span {
          display: inline-block;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #90FFF9;
          font-size: 20px;
        }
      }
      .en-tit {
        text-align: center;
        font-family: Source Han Sans CN;
        color: #fff;
        letter-spacing: 3px;
        font-size: 12px;
      }
    }
    .bt2 {
      .tit {
        span {
          color: #206B80;
        }
      }
      .en-tit {
        color: #3d3d3d;
      }
    }
    .txt {
      color: #fff;
      font-size: 14px;
      line-height: 24px;
      font-family: Microsoft YaHei;
      text-indent: 2em;
      text-align: justify;
    }
    .mar-txt {
      margin-bottom: 12px;
    }
    .box-1 {
      background: #1D6F8C;
      padding-bottom: 70px;
      .sign-in-btn {
        width: 169px;
        height: 27px;
        background: #13586E;
        border: 1px solid #F9E092;
        border-radius: 5px;
        margin: 30px auto 0;
        text-align: center;
        line-height: 27px;
        color: #fce7a5;
      }
    }
    .box-2 {
      background: #1D6F8C;
      padding-bottom: 26px;
      .txt {
        margin-bottom: 20px;
      }
      .award-list {
        display: flex;
        justify-content: space-between;
        .award-item {
          width: calc((100% - 29px) / 2);
          .icon {
            width: 40px;
            height: 40px;
            background: #176379;
            border: 1px solid #90FFF9;
            border-radius: 50%;
            padding-top: 10px;
            text-align: center;
            margin: 0 auto;
            position: relative;
          }
          .con {
            border: 1px solid #90FFF9;
            border-radius: 5px;
            padding: 15px 7px 0;
            margin-top: -5px;
            .a-tit, .a-txt {
              font-size: 14px;
              font-family: Source Han Sans CN;
              line-height: 24px;
            }
            .a-tit {
              font-weight: bold;
              text-align: center;
              color: #90FFF9;
            }
            .a-txt {
              color: #fff;
              text-indent: 2em;
            }
          }
        }
      }
    }
    .box-3 {
      background: linear-gradient(#f2f2f2, #fff);
      margin-bottom: 53px;
      .block-title {
        margin-bottom: 34px;
      }
      .al-tit {
        display: flex;
        margin-bottom: 10px;
        align-items: center;
        span {
          padding: 2px 10px;
          border: 1px solid #206B80;
          font-weight: bold;
          font-size: 14px;
          &:nth-child(1) {
            background: #206B80;
            color: #fff;
            font-weight: bold;
          }
          &:nth-child(2) {
            color: #206B80;
          }
          &:nth-child(3) {
            color: #206B80;
            text-align: right;
            flex-grow: 1;
            border: none;
            font-size: 15px;
          }
        }
      }
      .al-txt {
        color: #3d3d3d;
        line-height: 24px;
        font-size: 14px;
        text-indent: 2em;
        padding-bottom: 16px;
      }
      .item ~ .item {
        padding-top: 16px;
        border-top: 1px solid #cacaca50;
      }
    }
    .box-4 {
      .expert-list {
        font-size: 0;
        >* {
          display: inline-block;
          width: calc((100% - 33px) / 2);
          vertical-align: top;
        }
        .item {
          text-align: center;
          margin-bottom: 38px;
          &:nth-child(even) {
            margin-left: 33px;
          }
          img {
            width: 67px;
            border-radius: 50%;
            margin-bottom: 10px;
          }
          .el-tit {
            font-size: 14px;
            font-weight: bold;
            color: #206b80;
            letter-spacing: 4px;
          }
          .el-tit-en {
            letter-spacing: 0;
          }
          .el-txt {
            p {
              font-size: 12px;
              color: #363636;
            }
          }
        }
      }
      .point-msg {
        font-size: 10px;
        text-align: right;
      }
      margin-bottom: 40px;
    }
    .gfa-footer {
      padding-top: 24px;
      border-top: 1px solid #C1C2C4;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .f-left {
        p {
          font-size: 12px;
          line-height: 20px;
          color: #363636;
        }
      }
      .f-right {
        text-align: center;
        img {
          display: block;
          margin: 0 auto;
          width: 70px;
        }
        span {
          font-size: 12px;
          color: #363636;
        }
      }
    }
  }
}
</style>